import { render, staticRenderFns } from "./happy-space-video.vue?vue&type=template&id=709004f7&scoped=true&"
import script from "./happy-space-video.vue?vue&type=script&lang=js&"
export * from "./happy-space-video.vue?vue&type=script&lang=js&"
import style0 from "./happy-space-video.vue?vue&type=style&index=0&id=709004f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709004f7",
  null
  
)

export default component.exports